import { useContext } from 'react'
import { VideoDataContext } from '@contexts/index'

export const useVideoDataContext = () => useContext(VideoDataContext)
